// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoryModal-Form .Field {
  margin-bottom: 1rem;
}
.CategoryModal-Form .Field .Field-Label {
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--bs-primary);
  display: block;
}
.CategoryModal-Form .Field:has(+ .CategoryModal-Hint) {
  margin-bottom: 0.25rem;
}
.CategoryModal-Form .CategoryModal-Hint {
  display: block;
  margin-bottom: 1rem;
  color: var(--bs-gray-600);
}

.CategoryModal-Footer {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  padding: 1rem 0;
}
.CategoryModal-Footer .btn {
  flex-grow: 1;
  max-width: 10rem;
}`, "",{"version":3,"sources":["webpack://./src/features/Settings/pages/Categories/components/CategoryModal/styles.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AAEI;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AAAN;AAIE;EACE,sBAAA;AAFJ;AAKE;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AAJF;AAME;EACE,YAAA;EACA,gBAAA;AAJJ","sourcesContent":[".CategoryModal-Form {\n  .Field {\n    margin-bottom: 1rem;\n\n    .Field-Label {\n      text-transform: uppercase;\n      font-size: 0.8rem;\n      font-weight: 600;\n      color: var(--bs-primary);\n      display: block;\n    }\n  }\n\n  .Field:has(+ .CategoryModal-Hint) {\n    margin-bottom: 0.25rem;\n  }\n\n  .CategoryModal-Hint {\n    display: block;\n    margin-bottom: 1rem;\n    color: var(--bs-gray-600);\n  }\n}\n\n.CategoryModal-Footer {\n  display: flex;\n  justify-content: center;\n  gap: 1.5rem;\n  padding: 1rem 0;\n\n  .btn {\n    flex-grow: 1;\n    max-width: 10rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
